import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import DockwaPlusBadge from "./DockwaPlusBadge"

const DiscountedPrice = ({ label, amount, source, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between">
      {source === "dockwa_plus" ? (
        <DockwaPlusBadge label={label} />
      ) : (
        <span className="font-semibold">{label}</span>
      )}
      <span className="text-lg font-semibold text-gray-800">
        {formatCurrencyFromMinorUnits({ amount, currency })}
      </span>
    </div>
  )
}

DiscountedPrice.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  source: PropTypes.string,
  currency: PropTypes.string,
}

export default DiscountedPrice
